import { Component } from '@angular/core';

@Component({
  selector: 'app-update-patient-pharmacy',
  templateUrl: './update-patient-pharmacy.component.html',
  styleUrls: ['./update-patient-pharmacy.component.css']
})
export class UpdatePatientPharmacyComponent {

}
